var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-primary my-1 py-2 px-1",domProps:{"innerHTML":_vm._s(_vm.buttonText)},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }